exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-register {\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  background-position: center center;\r\n  height: 100%;\r\n  width: 100%;\r\n  padding: 5% 0;\r\n  position: fixed;\r\n}\r\n\r\n.login-box {\r\n  width: 450px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.login-box .footer {\r\n  width: 100%;\r\n  left: 0;\r\n  right: 0;\r\n}\r\n\r\n.login-box .social {\r\n  display: block;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n#recoverform {\r\n  display: none;\r\n}\r\n\r\n.login-sidebar {\r\n  padding: 0;\r\n  margin-top: 0;\r\n}\r\n\r\n.login-sidebar .login-box {\r\n  right: 0;\r\n  position: absolute;\r\n  height: 100%;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .login-register {\r\n    position: relative;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .login-box {\r\n    width: 90%;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = login.module